module.exports = __webpack_public_path__ + "assets/arrow-go.f53c143b.svg";